module.exports = __webpack_public_path__ + "static/media/dcypher_logo_1_320x320.fa993269.png";